import axios from "axios";
import { liveURL } from "../constants/Consts";

const AUDIT_LOGS_URL = `${liveURL}/v1/adminPortal/auditLogs`;

export const getAuditLogs = async (token, params = {}) => {
  try {
    const response = await axios.get(AUDIT_LOGS_URL, {
      headers: {
        token: token,
      },
      params: params,
    });
    return response.data;
  } catch (error) {
    console.error("Error in getAuditLogs:", error);
    return { Result: false, Msg: error.message };
  }
};

export const getAuditLogStats = async (token) => {
  try {
    const response = await axios.get(`${AUDIT_LOGS_URL}/stats`, {
      headers: {
        token: token,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error in getAuditLogStats:", error);
    return { Result: false, Msg: error.message };
  }
};

export const getAuditLogModules = async (token) => {
  try {
    const response = await axios.get(`${AUDIT_LOGS_URL}/modules`, {
      headers: {
        token: token,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error in getAuditLogModules:", error);
    return { Result: false, Msg: error.message };
  }
};

export const clearAuditLogs = async (token, days = null) => {
  try {
    const response = await axios.delete(`${AUDIT_LOGS_URL}/clear`, {
      headers: {
        token: token,
      },
      params: days ? { days } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error in clearAuditLogs:", error);
    return { Result: false, Msg: error.message };
  }
};
